import { createFileRoute } from '@tanstack/react-router';

import { FavoritesView } from 'views/FavoritesView';

export const Route = createFileRoute('/_auth/favorites')({
  component: FavoritesView,
});
